import { useSelector } from "react-redux";

import { isDevEnv } from "@utils/appUtils";

const useIsLithiumEnabled = () => {
  const isLithiumEnabled = useSelector(state => Boolean(state.projectInfo.activeCase?.isLithiumEnabled));
  return isDevEnv() && isLithiumEnabled;
};

export default useIsLithiumEnabled;
